import React, { useContext, useState } from "react";

import DataProvider, {
    DataContext,
} from "../../../../../providers/GasDataProvider";
import pushToAnalytics from "../../../../../utils/analytics";
import { storageLocal as storage } from "../../../../../utils/StorageHandler";
import NewInput from "../../../forms/NewInput";
import Button from "../../../NewForms/Button";
import { useNavigate } from "../provider";
import {
    ActionRow,
    FormContainer,
    FormRow,
    InputWrapper,
} from "../styledComponents";

const GasCalculator = () => {
    const dataContext = useContext(DataContext);

    const { zipcode, consumption } = dataContext.data;

    const [localZipcode, setLocalZipcode] = useState(zipcode);
    const [localConsumption, setLocalConsumption] = useState(consumption);
    const [zipcodeError, setZipcodeError] = useState(false);
    const [consumptionError, setConsumptionError] = useState(false);

    const onChangeZipcode = (event) => {
        if (event && !isNaN(event.target.value)) {
            setLocalZipcode(event.target.value);
        }
    };

    const onChangeConsumptionInput = (event) => {
        event.preventDefault();
        if (!isNaN(event.target.value)) {
            setLocalConsumption(event.target.value.toString());
        } else {
            setConsumptionError(true);
        }
    };

    const navigate = useNavigate("/gas");

    const handleClick = () => {
        if (
            localZipcode &&
            localZipcode.length === 5 &&
            typeof localZipcode == "string" &&
            !zipcodeError &&
            localConsumption &&
            !consumptionError
        ) {
            storage.set("gas:zipcode", localZipcode);
            storage.set("gas:consumption", localConsumption);
            pushToAnalytics("gas:calculate", {
                zipcode: localZipcode,
                consumption: localConsumption,
                dataGtag: "gas-calculate-default",
            });
            setTimeout(() => navigate(), 0);
        }
    };

    return (
        <FormContainer>
            <FormRow>
                <InputWrapper>
                    <NewInput
                        name="zipcode"
                        placeholder="Postleitzahl"
                        value={localZipcode}
                        onChange={onChangeZipcode}
                        validation="zipcode"
                        onError={() => setZipcodeError(true)}
                        onErrorSolved={() => {
                            setZipcodeError(false);
                        }}
                        required
                    />
                </InputWrapper>
                <InputWrapper>
                    <NewInput
                        name="consumption"
                        placeholder="kWh/Jahr"
                        value={localConsumption}
                        onChange={onChangeConsumptionInput}
                        validation="consumption"
                        onError={() => setConsumptionError(true)}
                        onErrorSolved={() => {
                            setConsumptionError(false);
                        }}
                        required
                    />
                </InputWrapper>
            </FormRow>
            <ActionRow>
                <Button onClick={handleClick} data-gtag="gas-calculate-default">
                    Preis berechnen
                </Button>
            </ActionRow>
        </FormContainer>
    );
};

const WithProvider = () => {
    return (
        <DataProvider>
            <GasCalculator />
        </DataProvider>
    );
};

export default WithProvider;
